import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { CLIENT_GET_ONE } from 'api/query-keys.ts';
import type { ClientRes } from 'api/swagger';

export const useGetClient = (id?: number) => {
  return useQuery<ClientRes>({
    queryKey: [CLIENT_GET_ONE, id],
    queryFn: async () => {
      const { data } = await http.get<ClientRes>(`/v1/clients/${id}`);
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 30 * 1000,
    enabled: !!id,
  });
};
